<h2 mat-dialog-title>Code
    of Conduct (Parents & Carers)</h2>
<mat-dialog-content class="mat-typography">
    <pdf-viewer [src]="'assets/rules.pdf'" [render-text]="true" style="display: block;">
    </pdf-viewer>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>